export default __webpack_public_path__ + "images/B6.7c5f673.png";